import styled from 'styled-components';
import ErrorMessageComponent from 'components/error-message';
import _TextareaAutosize from 'react-textarea-autosize';
import { withModifiers } from 'utils';
import { color } from 'styles/settings';

export const Container = styled.div``;

export const ErrorMessage = styled.div`
  position: relative;
  top: -15px;
`;

export const TextMessage = styled(ErrorMessageComponent)`
  position: relative;
  top: -15px;
`;

export const TextareaAutosize = styled(_TextareaAutosize)`
  border: none;
  box-sizing: border-box;
  overflow: hidden;

  ${withModifiers('$invalid')`
        border: 1px solid ${color.ui.danger};
    `};
`;
